<!--
  A container that will display a loading overlay on top of the child content.
-->
<template>
  <div class="Suspense">
    <div v-if="loading" class="loading">
      <div class="overlay" />
      <div class="spinner"></div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Suspense",
  props: {
    loading: Boolean,
  },
};
</script>

<style lang="scss">
.Suspense {
  position: relative;

  .loading {
    position: absolute;
    z-index: 99;
    display: flex;
    height: 100%;
    width: 100%;

    .overlay {
      position: absolute;
      height: 100%;
      width: 100%;
      background: rgba(255, 255, 255, 0.8);
    }

    .spinner {
      margin: auto;
    }
  }
}
</style>
